import type { ReasoningTrailResult } from './types'

export const REASONING_TRAIL_COPY = {
  BRAND: 'AI Operator',
  reviewedSteps: 'Reviewed steps outlined below',
  VIEW_ACCESS_LOGS: 'View access logs →',
} as const

export const REASONING_TRAIL_ARIA = {
  REGION: 'AI Operator Reasoning Trail',
  expandRow: (label: string) => `Expand reasoning for: ${label}`,
} as const

/** Human-readable result label (uppercased at render time). */
export const RESULT_LABEL: Record<ReasoningTrailResult, string> = {
  YES: 'Yes',
  NO: 'No',
  NOT_REQUIRED: 'Not required',
}
